const $$splitErrorComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/calendar/week.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_authenticated/tracking/calendar/week.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { rethrowUnlessUnauthorized } from '@/app/lib/redirect-to-login';
import { getScheduleWeekQuery } from '@/features/schedule/lib/get-schedule-week.query';
import { ScheduleSkeleton } from '@/features/schedule/ui/schedule-skeleton';
export const Route = createFileRoute('/_authenticated/tracking/calendar/week')({
  loader: async ({
    context,
    location
  }) => {
    const deps = {
      controllers: {
        scheduleController: context.deps.controllers.scheduleController
      }
    };
    try {
      await context.queryClient.ensureQueryData(getScheduleWeekQuery(deps));
    } catch (error) {
      await rethrowUnlessUnauthorized(error, context.queryClient, `${location.pathname}${location.searchStr}`);
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  pendingComponent: ScheduleSkeleton
});